import React, { useState } from 'react';
import {
	ExecutedCommand,
	FinishedCommand,
	RunableCommand,
} from '../Commands/Command';
import { useDispatch, useSelector } from 'react-redux';
import {
	selectNcziComands,
	setNcziCommands,
} from '../../../store/reducers/ncziSlice';

type ExecutedCommands = {
	[key: string]: ExecutedCommand | FinishedCommand;
};

export interface NCZICommandContextProps {
	commands: ExecutedCommands;
	addCommand: (command: RunableCommand) => void;
	updateCommand: (command: RunableCommand) => void;
}

export interface NCZIContextProviderProps {
	values?: NCZICommandContextProps;
	children?: React.ReactChild | React.ReactChild[];
}

export const NCZICommandContext = React.createContext<NCZICommandContextProps>({
	commands: {},
	addCommand: () => {},
	updateCommand: () => {},
});

export const useNCZICommandContext: () => NCZICommandContextProps = () =>
	React.useContext<NCZICommandContextProps>(NCZICommandContext);

export function NCZICommandContextProvider({
	values,
	children,
}: NCZIContextProviderProps) {
	// const [commands, setCommands] = useState<ExecutedCommands>({});
	const commands = useSelector(selectNcziComands);
	const dispatch = useDispatch();

	const addCommand = (command: RunableCommand) => {
		// setCommands(prevValue => {
		// 	const freshCommands = {...prevValue};
		// 	freshCommands[command.id] = {...command};
		// 	return freshCommands;
		// })
		const tmpCommands = { ...commands };
		tmpCommands[command.id] = { ...command };

		dispatch(setNcziCommands(tmpCommands));
	};

	const updateCommand = (command: RunableCommand) => {
		const freshCommands = { ...commands };

		if (!freshCommands[command.id]) {
			freshCommands[command.id] = { ...command };
		} else if (
			freshCommands[command.id].state !== 'done' &&
			freshCommands[command.id].state !== 'error'
		) {
			freshCommands[command.id] = { ...command };
		}

		// setCommands(freshCommands);
		dispatch(setNcziCommands(freshCommands));
	};

	return (
		<NCZICommandContext.Provider
			value={{
				commands,
				addCommand,
				updateCommand,
			}}>
			{children}
		</NCZICommandContext.Provider>
	);
}
